import { DateTime } from 'luxon'

export default class DateModel {
  static kebabFormat = 'yyyy-MM-dd'
  static kebabFormatWidthHM = 'yyyy-MM-dd HH:mm'
  static kebabFormatWidthHMS = 'yyyy-MM-dd HH:mm:ss'
  static dotFormat = 'yyyy.MM.dd'
  static dotFormatWidthHM = 'yyyy.MM.dd HH:mm'
  static dotFormatWidthHMS = 'yyyy.MM.dd HH:mm:ss'
  static timeFormat = 'HH:mm'
  static slashFormat = 'yyyy/MM/dd'
  
  readonly date: DateTime
  
  // UTC Time
  constructor(_date: string | number | Date | DateTime = DateTime.now()) {
    // timestamp
    if (typeof _date === 'number') {
      this.date = DateTime.fromSeconds(_date, { zone: 'utc' })
      return
    }
    if (typeof _date === 'string') {
      const format = this.getFormat(_date)
      // formatted
      if (format) {
        this.date = DateTime.fromFormat(_date, format, { zone: 'utc' })
        return
      }
      // ISO
      this.date = DateTime.fromISO(_date, { zone: 'utc' })
      return
    }
    // javascript Date
    if (_date instanceof Date) {
      this.date = DateTime.fromJSDate(_date, { zone: 'utc' })
      return
    }
    this.date = _date
  }
  
  private formatPatterns = {
    [DateModel.kebabFormatWidthHMS]: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/,
    [DateModel.kebabFormatWidthHM]: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/,
    [DateModel.kebabFormat]: /^\d{4}-\d{2}-\d{2}$/,
    [DateModel.dotFormatWidthHMS]: /^\d{4}\.\d{2}\.\d{2} \d{2}:\d{2}:\d{2}$/,
    [DateModel.dotFormatWidthHM]: /^\d{4}\.\d{2}\.\d{2} \d{2}:\d{2}$/,
    [DateModel.dotFormat]: /^\d{4}\.\d{2}\.\d{2}$/,
    [DateModel.timeFormat]: /^\d{2}:\d{2}$/,
    [DateModel.slashFormat]: /^\d{4}\/\d{2}\/\d{2}$/,
  } as const 

  public get localeTime(): DateTime {
    return this.date.setZone()
  }

  private getFormat(date: string): string | null {
    for (const [ format, pattern ] of Object.entries(this.formatPatterns)) {
      if (pattern.test(date)) {
        return format
      }
    }
    return null
  }
}
